<template>
  <el-row class="content-header">
    <el-col :span="24" class="d-flex justify-content-between align-items-center">
      <div class="el-col el-col-24">
        <div class="title"><i v-if="includeBack" class="el-icon-arrow-left c-highlight pointer" @click="back" />{{ title }}</div>
        <div class="sub-title" v-if="subTitle">
          {{ subTitle }}
        </div>
      </div>
      <div class="ml-10 slot">
        <slot />
      </div>
    </el-col>
    <el-col :span="24">
      <el-divider />
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'ContentHeaderCustom',
  props: {
    title: String,
    subTitle: String,
    backTo: String,
    includeBack: Boolean
  },
  methods: {
    back() {
      if (this.backTo) this.$router.push(this.backTo);
      else this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.content-header {
  margin-bottom: 1em;
  white-space: pre;

  .title {
    font-size: 1.5em;
    margin-top: 0.8em;
    margin-bottom: 0.5em;
  }

  .sub-title {
    font-size: 0.85em;
    margin-bottom: 1em;
    font-family: $fontLight;
    white-space: normal;
  }

  .slot {
    margin-top: 1em;
  }
}
</style>
